module.exports = __webpack_public_path__ + "media/images/pc/staffs/mv_planner@2x-6a76bad166b367e8ca1cd5e821647cf1.webp";